import { FC } from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Facebook: FC<Props> = ({ width = 33, height = 32, className, color = "#2A1645" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 33 32"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.8332 16.0001C29.8332 8.64008 23.8598 2.66675 16.4998 2.66675C9.13984 2.66675 3.1665 8.64008 3.1665 16.0001C3.1665 22.4534 7.75317 27.8267 13.8332 29.0667V20.0001H11.1665V16.0001H13.8332V12.6667C13.8332 10.0934 15.9265 8.00008 18.4998 8.00008H21.8332V12.0001H19.1665C18.4332 12.0001 17.8332 12.6001 17.8332 13.3334V16.0001H21.8332V20.0001H17.8332V29.2667C24.5665 28.6001 29.8332 22.9201 29.8332 16.0001Z"
        fill={color}
      />
    </svg>
  );
};

export default Facebook;
